import { render, staticRenderFns } from "./MoveInBillList.vue?vue&type=template&id=64d5910e&scoped=true&"
import script from "./MoveInBillList.vue?vue&type=script&lang=js&"
export * from "./MoveInBillList.vue?vue&type=script&lang=js&"
import style0 from "./MoveInBillList.vue?vue&type=style&index=0&id=64d5910e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5910e",
  null
  
)

export default component.exports